// Step 3 of the property wizard — "Hình ảnh & Media".
//
// Two modes:
//
//  - Create flow (no property id yet): {@link PendingImageBuffer}
//    collects File objects locally; the consuming page uploads them
//    after POST /properties returns the new id. Files preview via
//    object URLs and can be drag-reordered before publish.
//
//  - Edit flow (property id available): the full {@link ImageUploader}
//    is mounted directly, identical behavior to the property-edit page.

import { ImageUploader } from "@/features/property/components/image-uploader";
import {
  PendingImageBuffer,
  type PendingImage,
} from "@/features/property/wizard/steps/pending-image-buffer";

interface ImagesStepProps {
  /** Set in the edit flow once the property has been loaded. */
  propertyId: number | undefined;
  /** Buffered files (create flow only). */
  pendingImages?: readonly PendingImage[];
  /** Buffer setter (create flow only). */
  onPendingImagesChange?: (next: PendingImage[]) => void;
}

export function ImagesStep({
  propertyId,
  pendingImages,
  onPendingImagesChange,
}: ImagesStepProps) {
  return (
    <div className="flex flex-col gap-6">
      <h2 className="border-b border-border pb-2 text-[16px] font-bold tracking-tight">
        Hình ảnh & Media
      </h2>

      {propertyId !== undefined ? (
        <ImageUploader propertyId={propertyId} />
      ) : (
        <PendingImageBuffer
          images={pendingImages ?? []}
          onChange={onPendingImagesChange ?? (() => undefined)}
        />
      )}
    </div>
  );
}
